import { useMemo } from 'react';
import MojitoPresentation from 'mojito/presentation';
import SearchResultSection from 'applications/sports/components/search/search-discovery-view/search-result-section/index.js';
import { groupResultsByType, hasGroupedResults } from './utils.js';

const { FlexPane, Image, Spinner, Text } = MojitoPresentation.Components;

const SearchResultsList = props => {
    const {
        emptyText,
        items,
        onNavigate,
        pending,
        mojitoTools: { config, stringResolver },
    } = props;
    const grouped = useMemo(() => groupResultsByType(items), [items]);
    const hasResults = hasGroupedResults(grouped);

    if (pending && !hasResults) {
        return (
            <FlexPane config={config.loadingContainer} class="ta-searchResultsLoading">
                <Spinner config={config.spinner} />
            </FlexPane>
        );
    }

    if (!hasResults) {
        return (
            <Text config={config.emptyText} class="ta-searchResultsEmpty">
                {emptyText}
            </Text>
        );
    }

    const sections = [
        {
            key: 'sports',
            title: stringResolver.resolveString('$SEARCH_DISCOVERY_VIEW.SPORTS_SECTION_TITLE'),
            items: grouped.sports,
        },
        {
            key: 'competitions',
            title: stringResolver.resolveString('$SEARCH_DISCOVERY_VIEW.COMPETITIONS_TITLE'),
            items: grouped.competitions,
        },
        {
            key: 'events',
            title: stringResolver.resolveString('$SEARCH_DISCOVERY_VIEW.EVENTS_TITLE'),
            items: grouped.events,
        },
        {
            key: 'raceMeetings',
            title: stringResolver.resolveString('$SEARCH_DISCOVERY_VIEW.RACE_MEETINGS_TITLE'),
            items: grouped.raceMeetings,
        },
        ...Object.entries(grouped.playerGroups).map(([playerName, playerItems]) => ({
            key: `player-${playerName}`,
            title: stringResolver.resolveAndFormatString(
                '$SEARCH_DISCOVERY_VIEW.BET_ON_PLAYER',
                playerName
            ),
            items: playerItems,
            isPlayerGroup: true,
        })),
    ];

    return (
        <FlexPane config={config.container} class="ta-searchResultsList">
            <FlexPane config={config.titleContainer}>
                <Image config={config.titleIcon} />
                <Text config={config.title}>
                    {stringResolver.resolveString('$SEARCH_DISCOVERY_VIEW.SEARCH_RESULTS_TITLE')}
                </Text>
            </FlexPane>
            {sections
                .filter(section => section.items.length > 0)
                .map(section => (
                    <SearchResultSection
                        key={section.key}
                        config={config.section}
                        title={section.title}
                        items={section.items}
                        isPlayerGroup={section.isPlayerGroup}
                        onNavigate={onNavigate}
                    />
                ))}
        </FlexPane>
    );
};

export default SearchResultsList;
